import { PRODUCT_VERSION } from '@core/constants/core';

export const getCurrentProductVersion = () => {
  return localStorage.getItem(PRODUCT_VERSION) ?? null;
};
